import moment from "moment";
import React from 'react';
import {Col, Row} from 'react-grid-system';
import {connect} from "react-redux";
import {saveData, saveFormulariosData} from "../../../common/Actions";
import Btn from "../../../common/components/Btn/Btn";
import Date from "../../../common/components/Fields/Date";
import Files from "../../../common/components/Fields/Files";
import Select from "../../../common/components/Fields/Select";
import Provider from "../../../common/components/Provider/Provider";
import Helpers from "../../../common/Helpers";
import {resource} from "../../../common/lang/lang";
import Store from "../../../common/Store";
import ClientesService from "../../../services/Clients";
import ConsecutivoService from "../../../services/Consecutivo";
import ContratosService from "../../../services/Contratos";
import Model from "../Contrato.json";

class Formulario extends React.Component {

    Cities = resource('Cities');
    ContractType = resource('ContractType');
    _mounted = false;
    _init = {
        clientes: [],
        consecutivo: '----',
        date: moment().format('YYYY-MM-DD'),
    };

    constructor(props){
        super(props);
        this.state = this._init;
        this.props.save({formularios: {}, repetidos: {} });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.match) !== JSON.stringify(this.props.match)) {
            this.props.save({formularios: {}, repetidos: {} });
            this.setState(()=>({ edit: false }));
        }
    }

    componentDidMount() {
        this._mounted = true;
        this.getAll();
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    async getAll(){
        await this.getItems();
        let params = this.props.match.params;
        if( params.id ) await this.getData(params.id);
    }

    async getItems(){
        let [clientes] = await Promise.all([
            ClientesService.get(-1),
        ]);
        this.setState(()=>({ ...this._init, clientes: clientes.data }));
    }

    async getData(id){
        Helpers.loader();
        let client = await ContratosService.getById(id);
        if( client.data.id ){
            this.props.save({formularios: client.data });
            this.setState(()=>({ edit: true, consecutivo: client.data.consecutivo }));
        }else{
            this.props.history.push('/contrato/list');
        }
        Helpers.closeLoader();
    }

    save = async () => {
        let store = Store.getState();

        let form = {
            ...store.formularios,
        };

        let valid = Helpers.validForm(form, Model);
        if( valid.keys ){
            this.props.save({errors: valid.keys});
            Helpers.alert({title: 'Error!', text:valid.errors.join('\n')});
        }else{
            this.props.save({errors: {}});
            Helpers.loader();

            let consecutivo = await Promise.resolve(ConsecutivoService.get(4));
            form['consecutivo'] = this.state.consecutivo != '----' ? this.state.consecutivo : consecutivo.number.toString().padStart(4, '0');

            let method = 'save';
            if( this.state.edit ) method = 'update';
            let response = await ContratosService[method](form);
            Helpers.closeLoader();
            if( response.message ){
                Helpers.alert({title: 'Error!', text: response.message});
            }else if(response.status){
                if( this.state.edit ){
                    Helpers.alert({title: '', icon:'success', text: 'Se ha guardado correctamente!'});
                }else{
                    Helpers.alert({title: '', icon:'success', text: 'Se ha creado correctamente!'});
                }
                this.props.history.push('/contrato/list');
            }else{
                Helpers.alert({title: 'Error!', text: 'Error intente más tarde'});
            }
        }
    };

    return = () => this.props.history.push('/contrato/list');

    getContacts(){
        const {props:{cliente}, state:{clientes}} = this;
        for (let i = 0; i < clientes.length; i++) {
            if( clientes[i].id === cliente ) return clientes[i].contactos;
        }
        return [];
    }

    render() {
        const {edit, clientes, consecutivo, date} = this.state;
        return (
            <div className="formdata">
                <Row>
                    <Col>
                        <h2>{edit ? 'Editar' :'Nuevo'} Contrato</h2>
                    </Col>
                    <Col>
                        <div className="top">
                            <p>Consecutivo <span>{consecutivo}</span></p>
                            <p><span>{date}</span></p>
                        </div>
                    </Col>
                </Row>
                <div className="wrap">
                    <Provider save={saveFormulariosData} store="formularios">
                        <Row className="row">
                            <Col>
                                <div>
                                    <Select label="Seleccione el cliente" optionLabel={Helpers.clientsLabels} hash="id" opts={clientes} name="cliente" />
                                    <Select label="Seleccione el contacto" optionLabel={Helpers.clientsLabels} hash="id" opts={this.getContacts()} name="contact"/>
                                </div>
                                <h3 />

                                <div>
                                    <Date label="Fecha de inicio" name="init_date" />
                                    <Date label="Fecha de vencimiento" name="end_date" />
                                </div>
                                <div>
                                    <Select label="Objeto del contrato" opts={this.ContractType} name="objecto" />
                                    <Files name="file"/>
                                </div>
                            </Col>
                        </Row>
                    </Provider>
                </div>
                <Row>
                    <Col className="btns">
                        <Btn click={this.save} text="Guardar" type="primary" />
                        <Btn click={this.return} text="Cancelar" type="secondary" />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(
    (store) => ({cliente: store.formularios.cliente}),
    (dispatch) => ({save: data => dispatch(saveData(data))}),
)(Formulario);
